<template>
    <v-row v-if="!$store.getters.progress" class="ma-0 pb-offset">
        <v-col class="pa-0">
            <v-tabs
                app
                show-arrows
                :height="32"
                class="tabs-route"
                background-color="transparent"
                slider-color="primary">
                <v-tab
                    exact-path
                    ripple
                    :to="{ path: '/hremployees/' + id + '/'}"
                    key="hremployee">
                    Profilo
                </v-tab>
                <v-tab
                    exact-path
                    ripple
                    :to="{ path: '/hremployees/' + id + '/account'}"
                    key="hremployee-account">
                    Account
                </v-tab>
                <v-tab
                    exact-path
                    ripple
                    :to="{ path: '/hremployees/' + id + '/contracts'}"
                    key="hremployee-contracts">
                    Contratti
                </v-tab>
                <v-tab
                    exact-path
                    ripple
                    :to="{ path: '/hremployees/' + id + '/shift'}"
                    key="hremployee-shift">
                    Turno
                </v-tab>
                <v-tab
                    exact-path
                    ripple
                    :to="{ path: '/hremployees/' + id + '/attendance-config'}"
                    key="hremployee-attendance">
                    Timbratura
                </v-tab>
                <v-tab
                    v-if="canShowTfrTab"
                    exact-path
                    ripple
                    :to="{ path: '/hremployees/' + id + '/tfr'}"
                    key="hremployee-tfr">
                    TFR
                </v-tab>
                <v-tab
                    v-if="canShowAuditTab"
                    exact-path
                    ripple
                    :to="{ path: '/hremployees/' + id + '/audit'}"
                    key="hremployee-audit">
                    Audit
                </v-tab>
            </v-tabs>

            <v-slide-y-reverse-transition>
                <router-view v-show="!$store.getters.progress" :key="$route.fullPath" :entity-title="entityTitle"></router-view>
            </v-slide-y-reverse-transition>
        </v-col>
    </v-row>
</template>

<script>
    import breadcrumbEntityMixin from '@/mixins/breadcrumbEntityMixin'

    export default {
        mixins: [breadcrumbEntityMixin],
        name: 'hremployee-tabs',
        props: {
            id: Number,
        },

        data() {
            return {
                model: null,
            }
        },

        computed: {
            entityTitle() {
                return this.model ? ['first_name', 'last_name'].reduce((acc, key) => this.model[key] ? acc.concat(this.model[key]) : acc, []).join(' ') : ''
            },
            // Tab TFR/Audit gated dietro model caricato: evita flicker (mostra → nascondi)
            // perche' canActOn dipende da model.department_id (scope department/department_tree).
            canShowTfrTab() {
                if (!this.model || !this.model.id) return false
                return this.$store.getters.canActOn('hremployees', 'tfr', { id: this.id, department_id: this.model.department_id })
            },
            canShowAuditTab() {
                if (!this.model || !this.model.id) return false
                return this.$store.getters.canActOn('hremployees', 'audit', { id: this.id, department_id: this.model.department_id })
            },
        },

        created() {
            this.$store.commit('endProgress')
            this.axios.get('hremployees/' + this.id + '?&lite=1').then(response => {
                this.model = response.data.model
            }, response => {
                // error callback
            })
        },
    }
</script>
